import type { ProcedureType } from 'types/procedures'
import type { ProviderType, SpecialtyType } from 'types/providers'
import type { RoomType } from 'types/rooms'

import { getName } from 'utils/text'

export enum ScheduleFields {
  PROCEDURE_TYPES = 'procedureTypes',
  ROOM_IDS = 'roomIds',
  PROVIDER_IDS = 'providerIds',
  HAS_STEM_CELLS = 'hasStemCells',
}

//Convert data into options
export const convertToOptions = (
  data: Array<ProcedureType | RoomType | ProviderType | SpecialtyType>,
) =>
  data?.map(option => {
    let label = ''

    if ('name' in option) {
      label = option.name
    } else if ('value' in option) {
      label = option.value
    } else {
      label = getName(option)
    }

    return {
      value: option.id,
      label,
    }
  }) ?? []
